module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ;  var u = require('util/Util.js').default; 
    ; __append("\r\n<!-- 3 column layout -->\r\n<div class=\"page-title\">\r\n    <div class=\"row\">\r\n        <div class=\"col col-sm-12\">\r\n            <h1>")
    ; __append(escapeFn(dashboardTitle))
    ; __append("</h1>\r\n        </div>\r\n    </div>\r\n\r\n    <ol class=\"breadcrumb\">\r\n        ")
    ; 
        var count = breadcrumbs.length;
        var crumbCount = 0;
            _.forEach(breadcrumbs, function (crumb) {
                crumbCount++;
                if (crumbCount === count) { 
    ; __append("\r\n                  <li><span class=\"active\">")
    ; __append(escapeFn(crumb.name))
    ; __append("</span></li>\r\n                 ")
    ; 
                } else { 
    ; __append("\r\n                 <li><a href=\"#\" data-route=\"")
    ; __append(escapeFn(crumb.route))
    ; __append("\" id=\"")
    ; __append(escapeFn(crumb.id))
    ; __append("\">")
    ; __append(escapeFn(crumb.name))
    ; __append("</a></li>\r\n            ")
    ; 
                }
        }); 
    ; __append("\r\n    </ol>\r\n</div>\r\n<div class=\"connection row\" style=\"margin-top:10px; padding-right:50px;\">\r\n    <div class=\"col-md-6 actionGeneral\" style=\"padding-right:30px;\">\r\n        <div class=\"row\" style=\"margin-bottom: 0; padding-bottom: 0;\">\r\n            <div id=\"actionGeneral\"></div>\r\n        </div>\r\n        <div class=\"row\" style=\"margin-top: 0; padding-top: 0;\">\r\n            <div id=\"permissions\" style=\"padding-right: 30px;\"></div>\r\n        </div>\r\n        <div class=\"row\" style=\"padding:0;\">\r\n            <div id=\"actiondetails-twoCols\"></div>\r\n        </div>\r\n    </div>\r\n    <div class=\"col-md-6\">\r\n            <div id=\"actionDetails\"></div>\r\n    </div>\r\n</div>\r\n\r\n    <div class=\"row\" id=\"actionOperationsView\"></div>\r\n")
  }
  return __output;

}